module.exports = __webpack_public_path__ + "static/img/xiaolian@2x.b5f38c9f.png";